import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import { IFooterRow } from './report';
import { IOrderDeliveryTask, IPickupTask } from '../../../interfaces/delivery-company/tasks';

interface ReportTableFooterProps<T extends OrderType | IPickupTask | IOrderDeliveryTask> {
  table_footer_rows: IFooterRow<T>[];
  items: T[];
  color: string;
}

export function ReportTableFooter<T extends OrderType | IPickupTask | IOrderDeliveryTask>({
  table_footer_rows,
  items,
  color,
}: ReportTableFooterProps<T>) {
  const styles = StyleSheet.create({
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      height: "auto",
      fontSize: 8,
      fontWeight: 'bold',
      paddingTop: 3,
    },
    description: {
      width: '50%',
      paddingRight: 8,
    },
    total: {
      width: '50%',
      textAlign: 'right',
      paddingRight: 8,
    },
  });
  return (
    <>
      {table_footer_rows.map((row) => (
        <View style={styles.row} key={row.label} wrap={false}>
          <Text style={styles.description}>{row.label.toUpperCase()} </Text>
          <Text style={styles.total}> {row.compute_value(items)} </Text>
        </View>
      ))}
    </>
  );
}